import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { Location } from "@angular/common";
import { DevicesService } from "../devices.service";
import { RouterConfig } from "aws-sdk/clients/directconnect";
import { Device } from "../devices.model_new";
import { SessionStateService } from "../../../core/services/session-state.service";
import { GeneralService } from "../../../shared/services/general.service";
import { GROUP } from "../devices.constant";

import { DeviceTypesMap, DeviceType } from "../devices.constant";
import { EditDialogComponent } from "./edit-dialog/edit-dialog.component";
import { MatDialog, MatDialogRef, MatSliderChange } from "@angular/material";
import {
  ClimatizationDeviceTypesMap,
  ClimatizationDeviceType,
} from "../devices.constant";
import { Observable } from "rxjs";
import { empty } from "rxjs/Observer";
import { of } from "rxjs/observable/of";

@Component({
  selector: "app-device-detail",
  templateUrl: "./device-detail.component.html",
  styleUrls: ["./device-detail.component.scss"],
})
export class DeviceDetailComponent implements OnInit, OnDestroy {
  DeviceType = DeviceType;
  boxOn: boolean;
  loading: boolean;
  moduleId: string;
  device: Device;
  dialogRef: MatDialogRef<EditDialogComponent>;

  constructor(
    private devicesService: DevicesService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private generalService: GeneralService,
    private sessionStateService: SessionStateService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    if (this.showCoachMark("device-detail")) {
      this.scrollToBottom();
    }
    this.loading = true;
    this.route.params.subscribe((params: Params) => {
      this.moduleId = params["moduleId"];
      this.generalService
        .getBoxConnectionStatus()
        .flatMap((state) => {
          this.boxOn = state;
          return this.initComponent();
        })
        .finally(() => (this.loading = false))
        .catch((e) => of(empty))
        .subscribe();
    });

    this.generalService.connChange.subscribe((state) => {
      this.boxOn = state;
      if (state) {
        this.loading = true;
        this.initComponent()
          .finally(() => (this.loading = false))
          .subscribe();
      }
    });
  }

  initComponent() {
    return this.devicesService
      .getHouseModule(
        this.sessionStateService.getHouse().houseId,
        this.moduleId
      )
      .map((res) => {
        if (res.getModuleId()) {
          // console.log(res);
          this.device = res;
        } else {
          this.router.navigate(["/devices"]);
        }
      })
      .catch((err) => this.router.navigate(["/devices"]));
  }

  hasScheduling(): boolean {
    const groups: Set<GROUP> = this.device.getGroups();
    return (
      (groups.has(GROUP.SWITCH) || groups.has(GROUP.THERMOSTAT)) &&
      !groups.has(GROUP.PRODUCTION_METER)
    );
  }

  hasMetering(): boolean {
    const groups: Set<GROUP> = this.device.getGroups();
    return groups.has(GROUP.METERING);
  }

  OnGoBack() {
    this.location.back();
  }

  getLanguage() {
    return this.sessionStateService.getLang();
  }

  getBoxConnectionStatus() {
    return this.boxOn;
  }

  openDialog(device: Device): void {
    this.dialogRef = this.dialog.open(EditDialogComponent, {
      data: {
        device: device,
      },
      autoFocus: false,
      panelClass: "editPopup",
    });
    const lock = this.dialogRef.componentInstance.lockedEmitter.subscribe(
      (update: boolean) => {
        device.setUserAttribute("locked", update);
      }
    );
    if (this.device.getType() === DeviceType.CLIMATIZATION) {
      this.device.getGroups().forEach((group) => {
        if (
          ClimatizationDeviceTypesMap.map
            .get(ClimatizationDeviceType.AIR_CONDITIONING)
            .groups.includes(group)
        ) {
          const Categories = this.dialogRef.componentInstance.categoryUpdate.subscribe(
            (update: number[]) => {
              device.setUserAttribute("brand", update[0]);
              device.setUserAttribute("model", update[1]);
            }
          );
        }
        const Name = this.dialogRef.componentInstance.action.subscribe(
          (name: string) => {
            device.setName(name);
          }
        );
      });
    } else {
      const Name = this.dialogRef.componentInstance.action.subscribe(
        (name: string) => {
          device.setName(name);
        }
      );
      const Categories = this.dialogRef.componentInstance.categoryUpdate.subscribe(
        (update: number[]) => {
          device.setUserAttribute("category", update[0]);
          device.setUserAttribute("subcategory", update[1]);
        }
      );
    }
  }
  ngOnDestroy() {
    this.generalService.initConnChange();
  }

  showCoachMark(type) {
    return this.sessionStateService.getCoachMarkIndividualState().get(type);
  }

  scrollToBottom() {
    const scrollBottom = setInterval(() => {
      const elem = document.getElementById("line");
      if (elem) {
        elem.scrollIntoView();
      }
      clearInterval(scrollBottom);
    }, 1000);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/devices/device-detail/device-detail.component.ts